// AccountSettingsEditMode.jsx
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback, useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useSelector } from 'store/hooks/useSelector'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { Dropdown, InputText, MultiSelectDropdown } from 'ui_kit_qmd'
import './AccountSettingsEditMode.scss'
import { findIana } from 'windows-iana'
import {
  medicalProfessionOptions,
  onClickSafeMemberButton,
  prefixOptions,
  suffixOptions,
} from '../../../utils/AccountSettingsEditModeCommon'
import { EditMemberImage } from './edit-member-image/EditMemberImage'
import AccountSettingsPageTitle from '../AccountSettingsPageTitle/AccountSettingsPageTitle'
import { LOGOUT } from '../../../store/auth/AuthConstants'
import {
  setAccountSettingsError,
  setSettingsPageLoading,
  clearPhoneErrorAccount,
} from '../../../store/accountSettings/AccountSettingsActions'
import { editProviderProfileImage } from '../../../store/accountSettings/AccountSettingsThunk'
import { getTabId, parseTimeZone } from '../../../utils/common'
import { safeLocalStorage } from '@quickmd-llc/frontend-utils'
import TimeZoneSelect from '../../../components/time-zone-select/timeZoneSelect'
import { TIME_ZONE } from '../../../utils/constants'

import { checkPhone } from '../../../store/charts/ChartsThunk'
import { setPhoneErrorAction, clearPhoneErrorAction } from '../../../store/waitingRoom/WaitingRoomActions'
import { getUserFriendlyErrorMessage, errorCodes } from '../../../utils/errormessages'
import { setIsPhoneCorrect } from '../../../store/charts/ChartsActions'
import { PhoneInputV2 } from '../../../components/phone-input/PhoneInputV2'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import chartsReducer from '../../../store/charts/ChartsReducer'
// Style constants
const professionalTitleContainerStyle = {
  width: '603px',
  marginTop: 44,
  height: 60,
}

const professionalTitleDropdownStyle = {
  marginTop: 8,
  marginBottom: 24,
}

const emailLabelStyle = {
  whiteSpace: 'nowrap',
  cursor: 'default',
}

const emailContainerStyle = { width: '100%' }
const prefixContainerStyle = {
  width: '160px',
}
const prefixDropdownContainerStyle = {
  width: 158,
  marginTop: 8,
  maxHeight: 232,
  overflowY: 'hidden',
}
const editableFieldLabelStyle = {
  whiteSpace: 'nowrap',
  cursor: 'text',
}
const suffixContainerStyle = {
  width: '160px',
  marginLeft: 16,
}
const suffixDropdownContainerStyle = {
  width: 158,
  marginTop: 8,
  left: 16.5,
}
const arrowStyle = {
  alignSelf: 'center',
  right: 16,
}
const selectedOptionStyle = {
  padding: 0,
  margin: '0px 0px 0px 16px',
  height: 28,
  width: '92%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  position: 'absolute',
  bottom: 4,
}
const dropDownContainerStyle = {
  marginTop: 8,
  height: 260,
  zIndex: 999999999,
}
const timeZoneContainerStyle = {
  width: '100%',
  height: 60,
  display: 'flex',
  flexDirection: 'row',
  marginLeft: 0,
  marginTop: 44,
  paddingLeft: 0,
  position: 'relative',
}
const firstNameContainerStyle = { width: 427, marginLeft: 16 }
const lastNameContainerStyle = { width: 427 }

const AccountSettingsEditMode = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    toggleIsEditMode,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsConfirmationPopUpOpened,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setSaveChangesFromPopUp,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsChangedData,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    saveChangesFromPopUp,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    newActiveTab,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setNewActiveTab,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    phoneInputRef,
  }) => {
    const profile = useSelector((state) => state.waitingRoomReducer.providerProfile)
    const loading = useSelector((state) => state.waitingRoomReducer.loading)
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    const loadingAccount = useSelector((state) => state.accountSettings.loading)
    const [localInputError, setLocalInputError] = useState('')
    const dispatch = useDispatch()
    const navigate = useNavigate()
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    const { FirstName, LastName, Prefix, Suffix, ProfessionalTitles, PhoneNumber } = profile

    const [initialFirstName, setInitialFirstName] = useState('')
    const [initialLastName, setInitialLastName] = useState('')
    const [initialPrefix, setInitialPrefix] = useState('')
    const [initialSuffix, setInitialSuffix] = useState('')
    const [initialProfessionalTitles, setInitialProfessionalTitles] = useState('')
    const [originalTimeZone, setOriginalTimeZone] = useState(undefined)
    useEffect(() => {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setInitialFirstName(FirstName)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setInitialLastName(LastName)
      setInitialPrefix(Prefix)
      setInitialSuffix(Suffix)
      setInitialProfessionalTitles(ProfessionalTitles)

      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (profile.TimeZone) {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        const timezone = findIana(profile.TimeZone)[0]
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setOriginalTimeZone(timezone)
      }
    }, [])

    const [licensesArray, setLicensesArray] = useState([])
    const [email] = useState(profile?.Email)
    const [firstName, setFirstName] = useState(profile?.FirstName)
    const [firstNameError, setFirstNameError] = useState(false)
    const [firstNameLocalError, setFirstNameLocalError] = useState('')
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    const [prefix, setPrefix] = useState(profile?.Prefix ? profile.Prefix : ' ')
    const [lastName, setLastName] = useState(profile?.LastName)
    const [lastNameError, setLastNameError] = useState(false)
    const [lastNameLocalError, setLastNameLocalError] = useState('')
    const [professionalTitle, setProfessionalTitle] = useState('')
    const [professionalTitleError, setProfessionalTitleError] = useState(false)
    const [professionalTitleLocalError, setProfessionalTitleLocalError] = useState('')
    const [profileImgInputValue, setProfileImgInputValue] = useState(profile?.ImageUrl)
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    const [suffix, setSuffix] = useState(profile?.Suffix ? profile.Suffix : ' ')
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    const error = useSelector((state) => state.accountSettings.error)
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    const phoneErrorMessage = useSelector((state) => state.accountSettings.phoneErrorMessage)
    const isProcessingRef = useRef(false)
    const [isImageChanged, setIsImageChanged] = useState(false)
    const [isSaveBtnClicked, setIsSaveBtnClicked] = useState(false)
    const [professionalTitleDropdownOptions, setProfessionalTitleDropdownOptions] = useState([])
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    const [customTimeZone, setCustomTimeZone] = useState(profile.TimeZone ? findIana(profile.TimeZone)[0] : undefined)
    const initialTimeZone = parseTimeZone(null)

    const tabId = getTabId()

    useEffect(() => {
      if (!isImageChanged) {
        setProfileImgInputValue(profile?.ImageUrl)
      }
    }, [profile, isImageChanged])

    const [phoneCountryCode, setPhoneCountryCode] = useState('1')
    const [phoneCountry, setPhoneCountry] = useState('us')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [isCheckNumberInProgress, setIsCheckNumberInProgress] = useState(false)
    const [initialPhoneNumber, setInitialPhoneNumber] = useState('')
    const [isPhoneValidated, setIsPhoneValidated] = useState(false)

    const [lastValidatedPhoneNumber, setLastValidatedPhoneNumber] = useState('')
    const [lastValidatedCountryCode, setLastValidatedCountryCode] = useState('')

    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    const phoneError = useSelector((state) => state.waitingRoomReducer.phoneError)
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    const isPhoneCorrect = useSelector((state) => state.chartsReducer.isPhoneCorrect)

    const setPhoneErrorMessage = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (message) => {
        dispatch(setPhoneErrorAction(message))
      },
      [dispatch],
    )

    const clearPhoneErrorMessage = useCallback(() => {
      dispatch(clearPhoneErrorAction())
      dispatch(clearPhoneErrorAccount())
    }, [dispatch])

    useEffect(() => {
      console.log('here')
      clearPhoneErrorMessage()
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      dispatch(setIsPhoneCorrect(true))
    }, [clearPhoneErrorMessage, dispatch])

    useEffect(
      () => () => {
        dispatch(clearPhoneErrorAction())
        dispatch(clearPhoneErrorAccount())
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        dispatch(setIsPhoneCorrect(true))
      },
      [dispatch],
    )

    useEffect(() => {
      if (PhoneNumber) {
        const { Prefix: phonePrefix, Number, CountryCode } = PhoneNumber

        const extractedCountryCode =
          phonePrefix?.startsWith('+') && phonePrefix.replace('+', '') !== undefined ?
            phonePrefix.replace('+', '')
          : '1'

        setPhoneCountryCode(extractedCountryCode)
        setPhoneCountry(CountryCode ? CountryCode.toLowerCase() : 'us')

        const cleanedNumber =
          Number && phonePrefix && phonePrefix !== '+undefined' ? Number.replace(phonePrefix, '').trim() : ''
        setPhoneNumber(cleanedNumber)
        setInitialPhoneNumber(cleanedNumber)
      } else {
        setPhoneCountryCode('1')
        setPhoneCountry('us')
        setPhoneNumber('')
        setInitialPhoneNumber('')
      }
    }, [PhoneNumber])

    const validatePhoneNumber = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      async (currentCountryCode, currentPhoneNumber, currentCountry) => {
        if (!currentPhoneNumber.trim()) {
          clearPhoneErrorMessage()
          // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
          dispatch(setIsPhoneCorrect(true))
          setIsCheckNumberInProgress(false)
          setIsPhoneValidated(true)
          setLastValidatedPhoneNumber(currentPhoneNumber)
          setLastValidatedCountryCode(currentCountryCode)
          return
        }
        console.log('currentPhoneNumber', currentPhoneNumber)
        if (
          currentPhoneNumber === lastValidatedPhoneNumber &&
          currentCountryCode === lastValidatedCountryCode &&
          isPhoneValidated &&
          isPhoneCorrect
        ) {
          console.log('bogus')
          return { isValid: true }
          // Phone number hasn't changed since last validation; skip validation
        }

        setIsCheckNumberInProgress(true)
        try {
          console.log('currentPhoneNumber', currentPhoneNumber)
          dispatch(
            checkPhone({
              number: currentPhoneNumber,
              phoneCoutryCode: currentCountryCode,
              country: currentCountry,
              tabId,
            }),
          )
          setIsCheckNumberInProgress(false)
          // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
          dispatch(setIsPhoneCorrect(true))
          clearPhoneErrorMessage()
          setIsPhoneValidated(true)
          console.log('wwww')
          setLastValidatedPhoneNumber(currentPhoneNumber)
          setLastValidatedCountryCode(currentCountryCode)
          return { isValid: true }
        } catch (err) {
          console.log('smogis')
          setIsCheckNumberInProgress(false)
          // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
          dispatch(setIsPhoneCorrect(false))

          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          let errorMessage = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'Phone number')
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          if (err.message?.includes('PhoneNumberNotValid')) {
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            errorMessage = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'Phone number')
          }
          dispatch(setPhoneErrorAction(errorMessage))
          setIsPhoneValidated(false)
          setLastValidatedPhoneNumber('')
          setLastValidatedCountryCode('')
          return { isValid: false, errorMessage }
        }
      },
      [dispatch, clearPhoneErrorMessage, tabId, lastValidatedPhoneNumber, lastValidatedCountryCode, isPhoneValidated],
    )
    const onChangeNumber = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        if (/^\d*$/.test(value)) {
          setPhoneNumber(value)
          clearPhoneErrorMessage()
          if (value !== lastValidatedPhoneNumber) {
            // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
            dispatch(setIsPhoneCorrect(false))
            setIsPhoneValidated(false)
          } else {
            // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
            dispatch(setIsPhoneCorrect(true))
            setIsPhoneValidated(true)
          }
        }
      },
      [clearPhoneErrorMessage, dispatch, lastValidatedPhoneNumber],
    )

    const onChangeCountry = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      async (code, country) => {
        setPhoneCountryCode(code)
        setPhoneCountry(country.countryCode.toLowerCase())

        if (code !== lastValidatedCountryCode) {
          // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
          dispatch(setIsPhoneCorrect(false))
          setIsPhoneValidated(false)
        } else {
          // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
          dispatch(setIsPhoneCorrect(true))
          setIsPhoneValidated(true)
        }

        if (phoneNumber.trim()) {
          await validatePhoneNumber(code, phoneNumber, country.countryCode.toLowerCase())
        }
      },
      [dispatch, phoneNumber, validatePhoneNumber, lastValidatedCountryCode],
    )

    const onBlurNumber = useCallback(async () => {
      if (!isPhoneValidated && phoneNumber.trim()) {
        await validatePhoneNumber(phoneCountryCode, phoneNumber, phoneCountry)
      }
    }, [phoneNumber, phoneCountryCode, phoneCountry, validatePhoneNumber, isPhoneValidated])

    const hasPhoneNumberChanged = useCallback(() => {
      const initialPhoneNumberValue = initialPhoneNumber || ''
      const initialPhoneCountryCodeValue = PhoneNumber?.Prefix ? PhoneNumber.Prefix.replace('+', '') : '1'
      return phoneNumber !== initialPhoneNumberValue || phoneCountryCode !== initialPhoneCountryCodeValue
    }, [phoneNumber, initialPhoneNumber, phoneCountryCode, PhoneNumber])

    const onSafeEditedProvider = useCallback(async () => {
      try {
        const result = onClickSafeMemberButton(
          dispatch,
          setAccountSettingsError,
          firstName,
          setFirstNameLocalError,
          setFirstNameError,
          lastName,
          setLastNameLocalError,
          setLastNameError,
          email,
          () => {},
          () => {},
          prefix,
          suffix,
          'Provider',
          () => {},
          () => {},
          professionalTitle,
          setProfessionalTitleError,
          setProfessionalTitleLocalError,
          licensesArray,
          setLicensesArray,
          isImageChanged,
          tabId,
          customTimeZone === initialTimeZone ? null : customTimeZone,
          phoneCountryCode,
          phoneNumber,
          phoneCountry,
          isPhoneCorrect,
          // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
          isPhoneValidated,
        )

        if (!result) {
          // Validation failed; do not proceed
          console.log('Validation failed in onClickSafeMemberButton')
          return false // Return false to indicate failure
        }

        // Proceed to update initial states since validation passed
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setInitialFirstName(firstName)
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setInitialLastName(lastName)
        setInitialPrefix(prefix)
        setInitialSuffix(suffix)
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setOriginalTimeZone(customTimeZone)
        setInitialPhoneNumber(phoneNumber)

        setIsImageChanged(false)

        // Update both initial and current professional titles
        const updatedProfessionalTitles = professionalTitle
          .split(';')
          .map((t) => t.trim())
          .filter((t) => t)
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setInitialProfessionalTitles(updatedProfessionalTitles)
        setProfessionalTitle(updatedProfessionalTitles.join('; '))
      } catch (err) {
        console.error('Error saving provider profile:', err)
        // Handle error
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        let errorMessage = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'Phone number')
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        if (err.message?.includes('PhoneNumberNotValid')) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          errorMessage = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'Phone number')
        }
        dispatch(setPhoneErrorAction(errorMessage))
        setIsPhoneValidated(false)
      }
    }, [
      dispatch,
      firstName,
      lastName,
      email,
      prefix,
      suffix,
      professionalTitle,
      licensesArray,
      isImageChanged,
      tabId,
      customTimeZone,
      initialTimeZone,
      phoneCountryCode,
      phoneNumber,
      phoneCountry,
      isPhoneCorrect,
      isPhoneValidated,
    ])

    const updateProviderProfileImg = useCallback(() => {
      if (error) {
        setIsSaveBtnClicked(false)
      }
      if (profileImgInputValue !== '' && isImageChanged && !error) {
        const fr = new FileReader()
        // @ts-expect-error TS2531 -- MIGRATION: not approved, fix when encountered
        if (document.getElementById('profileImg').files[0]) {
          // @ts-expect-error TS2531 -- MIGRATION: not approved, fix when encountered
          fr.readAsDataURL(document.getElementById('profileImg').files[0])
        }
        const formData = new FormData()
        // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
        formData.append('Image', profileImgInputValue)
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        dispatch(editProviderProfileImage(formData))
      }
    }, [dispatch, error, profileImgInputValue])

    const hasProfileDataChanged = useCallback(() => {
      const correctSuffix = initialSuffix === null ? ' ' : initialSuffix
      const correctPrefix = initialPrefix === null ? ' ' : initialPrefix

      const initialPhoneNumberValue = initialPhoneNumber || ''
      const initialPhoneCountryCodeValue = PhoneNumber?.Prefix ? PhoneNumber.Prefix.replace('+', '') : '1'

      // Log all the values being compared
      console.log('--- hasProfileDataChanged Comparisons ---')
      console.log('initialFirstName:', initialFirstName)
      console.log('firstName:', firstName)
      console.log('FirstName Changed:', initialFirstName !== firstName)

      console.log('initialLastName:', initialLastName)
      console.log('lastName:', lastName)
      console.log('LastName Changed:', initialLastName !== lastName)

      console.log('correctSuffix:', correctSuffix)
      console.log('suffix:', suffix)
      console.log('Suffix Changed:', correctSuffix !== suffix)

      console.log('correctPrefix:', correctPrefix)
      console.log('prefix:', prefix)
      console.log('Prefix Changed:', correctPrefix !== prefix)

      console.log('initialProfessionalTitles:', JSON.stringify(initialProfessionalTitles))
      console.log('currentProfessionalTitles:', JSON.stringify(professionalTitle.split(';').map((t) => t.trim())))
      console.log(
        'ProfessionalTitles Changed:',
        JSON.stringify(initialProfessionalTitles) !== JSON.stringify(professionalTitle.split(';').map((t) => t.trim())),
      )

      console.log('isImageChanged:', isImageChanged)

      console.log('customTimeZone:', customTimeZone)
      console.log('originalTimeZone:', originalTimeZone)
      console.log('TimeZone Changed:', customTimeZone !== originalTimeZone)

      console.log('phoneNumber:', phoneNumber)
      console.log('initialPhoneNumberValue:', initialPhoneNumberValue)
      console.log('PhoneNumber Changed:', phoneNumber !== initialPhoneNumberValue)

      console.log('phoneCountryCode:', phoneCountryCode)
      console.log('initialPhoneCountryCodeValue:', initialPhoneCountryCodeValue)
      console.log('PhoneCountryCode Changed:', phoneCountryCode !== initialPhoneCountryCodeValue)

      console.log('---------------------------------------')

      return (
        initialFirstName !== firstName ||
        initialLastName !== lastName ||
        correctSuffix !== suffix ||
        correctPrefix !== prefix ||
        JSON.stringify(initialProfessionalTitles) !==
          JSON.stringify(professionalTitle.split(';').map((t) => t.trim())) ||
        isImageChanged ||
        customTimeZone !== originalTimeZone ||
        phoneNumber !== initialPhoneNumberValue ||
        phoneCountryCode !== initialPhoneCountryCodeValue
      )
    }, [
      initialSuffix,
      initialPrefix,
      initialFirstName,
      firstName,
      initialLastName,
      lastName,
      suffix,
      prefix,
      initialProfessionalTitles,
      professionalTitle,
      isImageChanged,
      customTimeZone,
      originalTimeZone,
      phoneNumber,
      initialPhoneNumber,
      phoneCountryCode,
      PhoneNumber,
    ])

    const onSafeBtnInPopUpClicked = useCallback(async () => {
      if (isProcessingRef.current) {
        // Function is already running, prevent re-invocation
        return
      }
      isProcessingRef.current = true
      console.log('onSafeBtnInPopUpClicked invoked')

      try {
        // Check if profile data has actually changed
        if (hasProfileDataChanged()) {
          if (hasPhoneNumberChanged() && !isPhoneValidated) {
            if (
              phoneNumber === lastValidatedPhoneNumber &&
              phoneCountryCode === lastValidatedCountryCode &&
              isPhoneCorrect
            ) {
              setIsPhoneValidated(true)
              // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
              dispatch(setIsPhoneCorrect(true))
            } else {
              const isValid = await phoneInputRef?.current?.validate()

              if (!isValid) {
                console.log('Phone number validation failed. Aborting save request.')
                setIsConfirmationPopUpOpened(false)
                setSaveChangesFromPopUp(false)
                return // Abort save action
              }
            }
          }

          const result = await onSafeEditedProvider()
          updateProviderProfileImg()
          if (!result) {
            setSaveChangesFromPopUp(false)
            setIsConfirmationPopUpOpened(false)
            console.log('Validation failed in onSafeEditedProvider')
            return
          }

          if (phoneNumber.trim() && !isPhoneCorrect) {
            setIsConfirmationPopUpOpened(false)
            setSaveChangesFromPopUp(false)
            return // Prevent navigation
          }

          setIsSaveBtnClicked(true)

          // Handle navigation or closing pop-up after saving changes
          if (newActiveTab?.redirect) {
            if (newActiveTab.redirect === 'logout') {
              setNewActiveTab('')
              dispatch({ type: LOGOUT, reason: 'manual' })
              safeLocalStorage.set('isSidePanelCollapsed', JSON.stringify(false))
            } else {
              navigate(`/${newActiveTab.redirect}`, { replace: true })
              setNewActiveTab('')
            }
            setIsChangedData(false)
          } else {
            setIsConfirmationPopUpOpened(false)
            toggleIsEditMode(false)
            setSaveChangesFromPopUp(false)
            setIsChangedData(false)
          }
        }
      } finally {
        isProcessingRef.current = false
      }
    }, [
      hasProfileDataChanged,
      hasPhoneNumberChanged,
      isPhoneValidated,
      onSafeEditedProvider,
      updateProviderProfileImg,
      phoneNumber,
      isPhoneCorrect,
      newActiveTab,
      lastValidatedPhoneNumber,
      phoneCountryCode,
      lastValidatedCountryCode,
      dispatch,
      phoneInputRef,
      setIsConfirmationPopUpOpened,
      setSaveChangesFromPopUp,
      setIsChangedData,
      setNewActiveTab,
      navigate,
      toggleIsEditMode,
    ])

    useEffect(() => {
      if (saveChangesFromPopUp) {
        onSafeBtnInPopUpClicked()
      }
    }, [saveChangesFromPopUp])

    const onSetProfessionalTitleOptions = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (newOptions) => setProfessionalTitleDropdownOptions(newOptions),
      [],
    )

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onSetFormValues = useCallback((type, value) => {
      switch (type) {
        case 'firstName': {
          if (value.length < 51) {
            setFirstNameLocalError('')
            setFirstNameError(false)
            setFirstName(value)
          }
          break
        }
        case 'lastName': {
          if (value.length < 51) {
            setLastNameLocalError('')
            setLastNameError(false)
            setLastName(value)
          }
          break
        }
        case 'ProfessionalTitle': {
          setProfessionalTitleLocalError('')
          setProfessionalTitleError(false)
          setProfessionalTitle(value)
          break
        }
        default:
          break
      }
    }, [])

    const onSetProfessionalTitleValue = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => onSetFormValues('ProfessionalTitle', value),
      [onSetFormValues],
    )

    useEffect(() => {
      updateProviderProfileImg()
    }, [isSaveBtnClicked])

    useEffect(() => {
      const newProfessionalTitleDropdownOptions = medicalProfessionOptions.map((t) => ({
        value: t,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isSelected: profile?.ProfessionalTitles?.includes(t),
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isActive: profile?.ProfessionalTitles?.includes(t),
      }))
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setProfessionalTitleDropdownOptions(newProfessionalTitleDropdownOptions)
    }, [])

    const onCancelBtnClicked = useCallback(async () => {
      if (hasProfileDataChanged()) {
        if (hasPhoneNumberChanged() && !isPhoneValidated) {
          if (
            phoneNumber === lastValidatedPhoneNumber &&
            phoneCountryCode === lastValidatedCountryCode &&
            isPhoneCorrect
          ) {
            setIsPhoneValidated(true)
            // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
            dispatch(setIsPhoneCorrect(true))
          } else {
            const isValid = await phoneInputRef?.current?.validate()
            if (!isValid) {
              return // Abort cancel action
            }
          }
        }
        setIsConfirmationPopUpOpened(true)
      } else {
        clearPhoneErrorMessage()
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        dispatch(setIsPhoneCorrect(true))
        toggleIsEditMode(false)
      }
    }, [
      hasProfileDataChanged,
      hasPhoneNumberChanged,
      isPhoneValidated,
      setIsConfirmationPopUpOpened,
      toggleIsEditMode,
      clearPhoneErrorMessage,
      dispatch,
      phoneNumber,
      phoneCountryCode,
      lastValidatedPhoneNumber,
      lastValidatedCountryCode,
      phoneInputRef,
    ])

    useEffect(() => {
      if (hasProfileDataChanged()) {
        setIsChangedData(true)
      } else {
        setIsChangedData(false)
      }
    }, [hasProfileDataChanged, setIsChangedData])

    const onSafeBtnHandler = useCallback(async () => {
      if (hasProfileDataChanged()) {
        if (hasPhoneNumberChanged() && !isPhoneValidated) {
          if (
            phoneNumber === lastValidatedPhoneNumber &&
            phoneCountryCode === lastValidatedCountryCode &&
            isPhoneCorrect
          ) {
            setIsPhoneValidated(true)
            // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
            dispatch(setIsPhoneCorrect(true))
            // Phone number hasn't changed and was previously validated successfully
          } else {
            return
          }
        }
        setIsSaveBtnClicked(true)

        const result = await onSafeEditedProvider()
        if (!result) {
          console.log('Validation failed in onSafeEditedProvider')
          return
        }

        setIsChangedData(false)
      } else {
        toggleIsEditMode(false)
        setIsChangedData(false)
      }
    }, [
      hasProfileDataChanged,
      hasPhoneNumberChanged,
      isPhoneValidated,
      isPhoneCorrect,
      onSafeEditedProvider,
      setIsChangedData,
      phoneNumber,
      lastValidatedPhoneNumber,
      phoneCountryCode,
      lastValidatedCountryCode,
      dispatch,
      phoneInputRef,
      toggleIsEditMode,
    ])

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onSetFirstName = useCallback((value) => onSetFormValues('firstName', value), [onSetFormValues])
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onSetLastName = useCallback((value) => onSetFormValues('lastName', value), [onSetFormValues])
    const onChangeTimeZoneGlobally = useCallback((newValueObject = {}) => {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      setCustomTimeZone(newValueObject.value ?? Intl.DateTimeFormat().resolvedOptions().timeZone)
    }, [])

    return (
      <>
        <AccountSettingsPageTitle
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          isEditMode
          onSafeBtnClicked={onSafeBtnHandler}
          onCancelBtnClicked={onCancelBtnClicked}
          toggleIsEditMode={toggleIsEditMode}
        />
        <div className='edit-settings-container-wrapper'>
          <div>
            <EditMemberImage
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              isVisible
              setPageStatus={setSettingsPageLoading}
              profileImgInputValue={profileImgInputValue}
              isImageChanged={isImageChanged}
              setProfileImgInputValue={setProfileImgInputValue}
              setIsImageChanged={setIsImageChanged}
            />
          </div>
          <div className='provider-edit-container'>
            <InputText
              disabled
              labelStyle={emailLabelStyle}
              containerStyle={emailContainerStyle}
              label='Email*'
              view='visitType'
              value={email}
              id='EmailFieldEditMember'
            />
            <div className='provider-inputs-row'>
              <Dropdown
                options={prefixOptions}
                containerStyle={prefixContainerStyle}
                dropdownContainerStyle={prefixDropdownContainerStyle}
                value={prefix}
                setValue={setPrefix}
                dropId='Prefix'
                label='Prefix'
              />
              <InputText
                labelStyle={editableFieldLabelStyle}
                containerStyle={firstNameContainerStyle}
                label='First name*'
                view='visitType'
                setValue={onSetFirstName}
                isError={firstNameError}
                localError={firstNameLocalError}
                value={firstName}
                id='FirstNameFieldEditMember'
              />
            </div>
            <div className='provider-inputs-row'>
              <InputText
                labelStyle={editableFieldLabelStyle}
                containerStyle={lastNameContainerStyle}
                label='Last name*'
                view='visitType'
                setValue={onSetLastName}
                isError={lastNameError}
                localError={lastNameLocalError}
                value={lastName}
                id='LastNameFieldEditMember'
              />
              <Dropdown
                options={suffixOptions}
                value={suffix}
                setValue={setSuffix}
                containerStyle={suffixContainerStyle}
                dropdownContainerStyle={suffixDropdownContainerStyle}
                dropId='Suffix'
                label='Suffix'
              />
            </div>
            <MultiSelectDropdown
              isRequired
              isEmptyMessage
              isWithSearch
              options={professionalTitleDropdownOptions}
              setOptions={onSetProfessionalTitleOptions}
              containerStyle={professionalTitleContainerStyle}
              dropdownContainerStyle={professionalTitleDropdownStyle}
              value={professionalTitle}
              setValue={onSetProfessionalTitleValue}
              dropId='Professional title'
              label='Professional title'
              isError={professionalTitleError}
              localError={professionalTitleLocalError}
            />
            <TimeZoneSelect
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              onSetCurrentDateTimeZone={onChangeTimeZoneGlobally}
              customSelectedTimezone={customTimeZone}
              containerStyle={timeZoneContainerStyle}
              arrowStyle={arrowStyle}
              selectedOptionStyle={selectedOptionStyle}
              label={TIME_ZONE}
              dropDownContainerStyle={dropDownContainerStyle}
              useDefault
            />

            <PhoneInputV2
              ref={phoneInputRef}
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              id='account-settings-phone-input'
              className='account-settings-phone'
              inputLabel='Phone number'
              setCountryCode={setPhoneCountryCode}
              phoneCountry={phoneCountry}
              phoneNumber={phoneNumber}
              phoneCountryCode={phoneCountryCode}
              onChangeCountry={onChangeCountry}
              onChangeNumber={onChangeNumber}
              onBlurNumber={onBlurNumber}
              isPhoneCorrect={isPhoneCorrect}
              checkedPhoneNumber={phoneNumber}
              isOldNumberCorrect={isPhoneCorrect}
              // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
              setIsPhoneCorrect={(value) => dispatch(setIsPhoneCorrect(value))}
              setPhoneError={setPhoneErrorMessage}
              clearPhoneError={clearPhoneErrorMessage}
              error={phoneError || phoneErrorMessage}
              disabled={false}
              loading={isCheckNumberInProgress || loading || loadingAccount}
              isDisableAutocomplete
              allowEmpty
              enableExplicitValidation
              validatePhoneNumber={validatePhoneNumber}
              isPhoneValidated={isPhoneValidated}
              setIsPhoneValidated={setIsPhoneValidated}
              setLocalInputError={setLocalInputError}
              localInputError={localInputError}
            />
          </div>
        </div>
      </>
    )
  },
)

export default AccountSettingsEditMode
